import { useGLTF } from '@react-three/drei';
import { Canvas, useFrame } from '@react-three/fiber';
import { mix } from 'motion';
import React, { useRef } from 'react';
import { Group } from 'three';

interface BoogieBoardProps {
    hovered: any
}

const toRad = (deg: number) => Math.PI * (1 / 180) * deg;
const xBounceDuration = 6;
const yBounceDuration = 6.5; // seconds
const zBounceDuration = 7;
const circumference = 2 * Math.PI;

const BoogieBoard: React.FC<BoogieBoardProps> = ({ hovered }) => {
    const ref = useRef<Group>(null!);
    const { nodes, materials }: any = useGLTF('/thg/3d/boogie_package.glb');

    const rangeRotateNaturalX = mix(0, toRad(10));
    const rangeRotateNaturalY = mix(0, toRad(10));

    const rangeRotateModX = mix(0, toRad(40));
    const rangeRotateModY = mix(0, toRad(40));

    const rangeRotateZ = mix(0, Math.PI * (10 / 180));

    const modX = useRef(0);
    const modY = useRef(0);

    useFrame(({ clock, pointer }, delta) => {
        const t = clock.getElapsedTime();

        const naturalX = rangeRotateNaturalX(Math.sin((t * circumference / xBounceDuration)));
        const naturalY = rangeRotateNaturalY(Math.sin((t * circumference / yBounceDuration)));
        const naturalZ = rangeRotateZ(Math.sin((t * circumference) / zBounceDuration));

        modX.current = (rangeRotateModX(pointer.x))
        modY.current = (rangeRotateModY(pointer.y))

        ref.current.rotation.y = naturalX + modX.current;
        ref.current.rotation.x = naturalY + modY.current;
        ref.current.rotation.z = naturalZ;

        ref.current.position.y = (.25 + (.5 * (Math.cos((t * circumference) / yBounceDuration))));
    })

    return (
        <group
            ref={ref}
        >
            <mesh receiveShadow castShadow geometry={nodes.Package.geometry} material={materials.Package} scale={2.5} />
        </group>
    )
}

const BoogieBoardCard: React.FC = () => {
    const hovered = useRef(false);

    const handleOnPointerOver = () => {
        hovered.current = true;
    }

    const handleOnPointerOut = () => {
        hovered.current = false;
    }

    return (
        <div className='shadow-xl h-96 w-72 bg-white bg-opacity-60 relative'>
            <Canvas
                camera={{ position: [0, 0, -5], fov: 70 }}
                onPointerOver={handleOnPointerOver}
                onPointerDown={handleOnPointerOut}
            >
                <ambientLight intensity={.7} />
                <spotLight intensity={300} angle={.1} penumbra={8} position={[2, 3, -5]} castShadow />
                <directionalLight color='white' position={[0, 0, -5]} />

                <BoogieBoard hovered={hovered} />
            </Canvas>
            <div className='w-full flex justify-center items-center bg-red-500 pt-2 bottom-0 absolute'>
                <h2 className='text-white italic text-teko font-semibold text-4xl'>LCD Life Pad</h2>
            </div>
        </div>
    )
}

export default BoogieBoardCard;